import React from 'react';
import { Link } from "gatsby";
import './_breadcrumb.scss';


const Breadcrumb = (props) =>
  (<ol className="breadcrumb">
		<li className="breadcrumb-item">
		     <Link to="/">Home</Link>
		 </li>
		<li className="breadcrumb-item active">{props.title}</li>
	</ol>);

export default Breadcrumb;
